import  request  from '../../Interceptor/request.js'

//首页轮播图获取
export function bannerList() {
    return request({
        url: '/banner/list',
        method: 'get'

    })
}

//首页获取六个月缴费数据的折线图
export function chart(){
    return request({
        url:'/order/trend',
        method: 'get'
    })
}

//首页资讯
export function realTime(){
    return request({
        url:'/information/list',
        method: 'get'
    })
}

//首页缴费信息
export function payment(){
    return request({
        url:'/paymentInfo/list',
        method:'get'
    })
}

//首获取个人信息
export function person(){
    return request({
        url:'/member',
        method:'get'
    })
}

//微信小程序登录
export function miniwxLogin(appid, code){
    return request({
        url:`/miniapp/user/${appid}/login?code=${code}`,
        method:'get'
    })
}
//微信公众号登录
export function gzhLogin(appid, code){
    return request({
        url:`/wx/redirect/${appid}/greet?code=${code}`,
        method:'get'
    })
}
// export function gzhLogin(appid, code){
//     return request({
//         url:`/miniapp/user/${appid}/loginByGzh?code=${code}`,
//         method:'get'
//     })
// }

